import React, { useEffect, useState } from "react";
import { Navbar } from "../../components/Navbar";
import { HeaderCourses } from "../../components/HeaderCourses";
import { ResumeCourses } from "../../components/ResumeCourses";
// import { CoursesContentSection } from "../../components/CoursesContentSection";
import { Footer } from "../../components/Footer";
import { CourseCard } from "../../components/CourseCard";
// import { useMoodle } from "../../contexts/MoodleContext";
import { CustomSpinner } from "../../components/Loader/custom.spinner";
import { FormSence } from "../../services/sence/form";
import { useNavigate } from "react-router-dom";
import { CustomDialog } from "../../components/Dialog";
import { defaultSenceValidation } from "../../utils/handler";
import { getUserNru } from "../../services/tipddy/nru";
import { useAuth } from "../../contexts/AuthContext";
import { Snackbar } from "../../components/Snackbar";
import { THEME_CONTEXT, THEME_SEVERITY } from "../../utils/theme";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { Search, X } from "lucide-react";
import { Pagination } from "../../components/Pagination";
import { DEFAULT_SNACKBAR } from "../../utils/snackbar";
import { STRINGS } from "../../utils/strings";
import { loginMoodle, resetPasword } from "../../services/moodle/userauth";
import { useMoodleV2 } from "../../contexts/moodle";
import { useConfig } from "../../contexts/config";

const ListCourses = () => {
  const auth = useAuth();
  const { lang, dictionary } = useAuth();
  const isSence = localStorage.getItem("sence_session");
  const currentCourse = localStorage.getItem("current_course");
  const moodle = useMoodleV2();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(!moodle.courses);
  // const moodleV2 = useMoodleV2();
  const [modalForcePassword, showModalForcePassword] = useState(false);
  const [msg, setMsg] = React.useState({
    open: false,
    title: "",
    msg: "",
    confirm: "Ir a Home",
    cancel: "Ir al curso",
  });
  const config = useConfig();
  const [categoryMap, setCategoryMap] = React.useState({});
  const [terms, setTerms] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const ITEMS_PER_PAGE = 12;

  const filteredCourses = React.useMemo(() => {
    if (!moodle.courses || !Array.isArray(moodle.courses)) return [];
    if (!searchTerm.trim()) return moodle.courses;
    const term = searchTerm.toLowerCase().trim();
    return moodle.courses.filter((course) => {
      const fullname = (course.fullname || course.displayname || "").toLowerCase();
      const shortname = (course.shortname || "").toLowerCase();
      const idnumber = (course.idnumber || "").toLowerCase();
      const category = (course.categoryname || categoryMap[course.categoryid] || categoryMap[course.category] || "").toLowerCase();
      return (
        fullname.includes(term) ||
        shortname.includes(term) ||
        idnumber.includes(term) ||
        category.includes(term)
      );
    });
  }, [moodle.courses, searchTerm, categoryMap]);

  React.useEffect(() => {
    setPage(1);
  }, [searchTerm]);

  const totalPages = Math.ceil(filteredCourses.length / ITEMS_PER_PAGE);

  const paginatedCourses = React.useMemo(() => {
    const start = (page - 1) * ITEMS_PER_PAGE;
    return filteredCourses.slice(start, start + ITEMS_PER_PAGE);
  }, [filteredCourses, page]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    const targetElement = document.getElementById("courses-section");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

React.useEffect(() => {
  const fetchCategories = async () => {
    try {
      const categories = await moodle.getCategories();
      if (categories) {
        const map = categories.reduce((acc, cat) => {
          acc[cat.id] = cat.name;
          return acc;
        }, {});
        setCategoryMap(map);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  
  // Solo ejecutar si categoryMap está vacío
  if (Object.keys(categoryMap).length === 0) {
    fetchCategories();
  }

  // fetch terms from config
  if(auth.user?.customfields && auth.termsAccepted === false){
    const termsField = auth.user.customfields.find(field => field.shortname === 'terms_accepted');
    if(termsField && termsField.value === "0"){
      auth.setTermsAccepted(false)
    } else {
      auth.setTermsAccepted(true)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []); // Array vacío - solo se ejecuta UNA VEZ al montar el componente


  React.useEffect(() => {
    moodle.getCourses();
    if (localStorage.getItem(STRINGS.FORCEPASSWORD_ERROR_CODE)) {
      showModalForcePassword(true);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    React.useEffect(() => {
      moodle.setPageEmbed(null)
    }, [])

  React.useEffect(() => {
    console.log("moodle courses: ",moodle.courses)
    console.log("config baseURl: ", btoa(config.config.baseURL))
    if (moodle.courses && moodle.courses.length > 0) {
      //console.log(auth.user)
      //
      /* getUserNru({
        courseid: moodle.courses[0].id,
        userid: auth.user.id,
        username:auth.user.username
      }).then((res) => {
        console.log(res)
      }) */
      //
      let size = moodle.courses.length;
      //console.log("size: ", size)
      if (size === 1) {
        let isSenceCourse = defaultSenceValidation(moodle.courses[0]);
        if (isSenceCourse.isSence) {
          console.log('is sence')
          getUserNru({
            // userid: auth.user.id,
            clientid: config.config.ID,
            courseid: moodle.courses[0].id,
            username: auth.user.username,
            urlmoodle: config.config.baseURL
          }).then((res) => {
            if (res && res.length > 0) {
              let isNRU = res[0].rnu;
              if (isNRU && isSenceCourse.isSence) {
                setLoading(false);
                setMsg({
                  ...msg,
                  open: true,
                  title: "Bienvenido a Alumnos",
                  confirm: "Ir a Inicio",
                  cancel: "Iniciar sesion en Sence",
                });
              }
            } else {
              setLoading(false);
              setMsg({
                ...msg,
                open: true,
                msg: "Selecciona la navegacion",
                title: "Bienvenido a Alumnos",
              });
            }
          });
        } else {
          window.location.replace(`/detailcourse/${moodle.courses[0].id}`);
        }
      } else {
        setLoading(false);
      }
    }

    if (moodle.courses && moodle.courses.length === 0) {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [moodle.courses]);

  React.useEffect(() => {
    if (isSence) navigate(`/detailcourse/${currentCourse}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onCancel() {
    setMsg({ ...msg, open: false });
    navigate(`/detailcourse/${moodle.courses[0].id}`);
  }

  function onConfirm() {
    setMsg({ ...msg, open: false });
  }

  const renderPageView = () => {
    const searchSlot = (
      <div className="relative w-full tablet:w-80 max-w-full">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
          <Search size={18} />
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={
            dictionary?.Home?.search_placeholder ||
            (lang === "en" ? "Search courses..." : "Buscar cursos...")
          }
          className="w-full h-11 pl-10 pr-10 bg-white border border-gray-300 rounded-lg text-base text-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#44BCF9] focus:border-transparent"
        />
        {searchTerm && (
          <button
            type="button"
            onClick={() => setSearchTerm("")}
            className="absolute inset-y-0 right-0 pr-2.5 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition"
            aria-label={dictionary?.Home?.clear_search || "Limpiar búsqueda"}
          >
            <X size={18} />
          </button>
        )}
      </div>
    );

    const paginationSlot = totalPages >= 1 ? (
      <div className="flex flex-col items-center gap-2">
        <Pagination
          page={page}
          totalPages={totalPages}
          onChange={handlePageChange}
        />
      </div>
    ) : null;

    return (
      <>
        {lang && (
          <>
            <FormSence />
            <Navbar />
            <HeaderCourses moodle={moodle} lang={lang} />
            <ResumeCourses
              searchSlot={moodle.courses && moodle.courses.length > 0 ? searchSlot : null}
              paginationSlot={paginationSlot}
            >
              {paginatedCourses.length > 0 ? (
                paginatedCourses.map((item, idx) => {
                  const overviewfiles = Array.isArray(item.overviewfiles)
                    ? item.overviewfiles
                    : [];
                  const imgurl =
                    overviewfiles.length > 0 ? moodle.getCourseImg(item) : "";
                  const categoryName =
                    item.categoryname ||
                    categoryMap[item.categoryid] ||
                    categoryMap[item.category] ||
                    "";

                  return (
                    <CourseCard
                      key={item.id || idx}
                      categoryName={categoryName}
                      item={item}
                      moodle={moodle}
                      lang={lang}
                      imgurl={imgurl}
                    />
                  );
                })
              ) : moodle.courses && moodle.courses.length > 0 ? (
                <div className="col-span-full py-12 text-center w-full">
                  <p className="text-lg font-medium text-gray-500 dark:text-gray-400 mb-4">
                    {dictionary?.Home?.no_courses_found ||
                      "No se encontraron cursos que coincidan con la búsqueda."}
                  </p>
                  <button
                    type="button"
                    onClick={() => setSearchTerm("")}
                    className="px-4 py-2 text-sm font-semibold rounded-lg bg-sky-500 hover:bg-sky-600 text-white transition shadow"
                  >
                    {dictionary?.Home?.clear_search || "Limpiar búsqueda"}
                  </button>
                </div>
              ) : null}
            </ResumeCourses>
            <Footer />
            <CustomDialog
              open={msg.open}
              onConfirm={onConfirm}
              onCancel={onCancel}
              title={msg.title}
              confirm={msg.confirm}
              cancel={msg.cancel}
              courseid={
                moodle &&
                moodle.course &&
                moodle.courses.length > 0 &&
                moodle.courses[0].id
              }
              moodle={moodle}
              message={msg.msg}
              countdown
            />
            <ForcePasswordModal open={modalForcePassword} />
            {/* <AcceptTermsModal /> */}
          </>
        )}
      </>
    );
  };

  return <>{loading ? <CustomSpinner /> : renderPageView()}</>;
};

const AcceptTermsModal = () => {
const {termsAccepted, lang} = useAuth();
const {config} = useConfig();
  const [expandedSection, setExpandedSection] = useState(null);
  const [terms, setTerms] = useState(null);
  const [privacy, setPrivacy] = useState(null);
  const [loading, setLoading] = useState(false); // Para mostrar estado de carga


    useEffect(() => {
      if (!config) return;
  
      console.log(config);
      if(lang === "es"){
        if (config.terminos_y_condiciones.terms_es) {
          setTerms(config.terminos_y_condiciones.terms_es);
        }
        if (config.politica_de_privacidad) {
          setPrivacy(config.politica_de_privacidad.privacy_policy_es);
        }
      } else {
        if (config.terminos_y_condiciones.terms) {
          setTerms(config.terminos_y_condiciones.terms);
        }
        if (config.politica_de_privacidad) {
          setPrivacy(config.politica_de_privacidad.privacy_policy);
        }
      }
      
    }, []);


  if (termsAccepted === true) {
    return null;
  }

    const handleAcceptTerms = async () => {
    setLoading(true);
    try {
      //await acceptTerms();
    } catch (error) {
      console.error('Error al aceptar términos:', error);
      // Podrías mostrar un snackbar de error aquí
    } finally {
      setLoading(false);
    }
  };


  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg shadow-xl p-6 max-w-[90%] laptop:max-w-[50%] w-full mx-4  max-h-[60vh] overflow-hidden flex flex-col">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Términos y Condiciones
          </h2>
          <p className="text-gray-600 mb-4">
            Por favor, revisa y acepta los términos y condiciones para continuar.
          </p>
          
          {/* Acordeones */}
          <div className="flex-1 overflow-y-auto mb-4 space-y-2">
            {/* Términos de Uso */}
            <div className="border border-gray-200 rounded-lg">
              <button
                onClick={() => toggleSection('terms')}
                className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
              >
                <span className="font-medium text-gray-700">Términos de Uso</span>
                <svg
                  className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                    expandedSection === 'terms' ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {expandedSection === 'terms' && (
                <div className="px-4 pb-4 text-gray-600 border-t border-gray-100">
                  <div className="pt-3 space-y-2">
                  <div className="font-poppins **:!text-[20px] [&_a]:text-[14px] **:m-0 [&_a]:m-0" dangerouslySetInnerHTML={{ __html: terms }}></div>
                  </div>
                </div>
              )}
            </div>

            {/* Política de Privacidad */}
            <div className="border border-gray-200 rounded-lg">
              <button
                onClick={() => toggleSection('privacy')}
                className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
              >
                <span className="font-medium text-gray-700">Política de Privacidad</span>
                <svg
                  className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                    expandedSection === 'privacy' ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {expandedSection === 'privacy' && (
                <div className="px-4 pb-4  text-gray-600 border-t border-gray-100">
                  <div className="pt-3 space-y-2">
                    <div className=" **:!text-[20px] [&_a]:text-[14px] **:m-0 [&_a]:m-0" dangerouslySetInnerHTML={{ __html: privacy }}></div>
                  </div>
                </div>
              )}
            </div>
          </div>

         <div className="flex justify-end gap-3 pt-2 border-t border-gray-100">
            <button
              onClick={handleAcceptTerms}
              disabled={loading}
              className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Guardando...' : 'Aceptar'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

const ForcePasswordModal = ({ open }) => {
  const auth = useAuth();
  const { lang, dictionary } = useAuth();
  const navigate = useNavigate();
  const moodlev2 = useMoodleV2();

  const [snackbar, setSnackbar] = useState({
    severity: "",
    visible: false,
    message: "",
  });
  const [errorAuth, setErrorAuth] = useState({
    error: false,
    message: "",
  });
  const [credentials, setCredentials] = useState({
    lastPassword: "",
    newPassWord: "",
    confirmPassword: "",
  });

  const handleSubmit = async () => {
    let username = localStorage.getItem("username");
    // let token = localStorage.getItem("token");
    try {
      await loginMoodle({ username, password: credentials.lastPassword });
      let reseted = await resetPasword({
        username,
        password: credentials.newPassWord,
        forcepasswordchange: 1,
      });

      localStorage.removeItem(STRINGS.FORCEPASSWORD_ERROR_CODE);

      setSnackbar({
        visible: true,
        message: lang["Snackbars"].success_change,
        severity: THEME_SEVERITY.SUCCESS,
      });

      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
        auth.logout(moodlev2);
        navigate("/");
      }, 5000);

      console.log({ reseted });
    } catch (err) {
      setErrorAuth({
        error: true,
        message: "Error al validar la contraseña anterior",
      });
      console.log(err);
    }
  };

  return (
    <>
      <div>
        <Dialog
          fullWidth
          open={open}
          /* onClose={handleClose} */ PaperProps={{
            style: {
              backgroundColor: THEME_CONTEXT.NAV_LIGHT,
              paddingBottom: ".7rem",
            },
          }}
        >
          <DialogTitle
            sx={{
              backgroundColor: THEME_CONTEXT.DARK_MODE_BTN,
              color: "#fff",
              fontSize: 16,
              fontFamily:
                "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif",
            }}
          >
            {dictionary.Forcepassword.title}
          </DialogTitle>
          <DialogContent className="mt-3">
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label={dictionary.Forcepassword.first_input}
              type="email"
              fullWidth
              variant="standard"
              value={credentials.lastPassword}
              onChange={(e) =>
                setCredentials({ ...credentials, lastPassword: e.target.value })
              }
              inputProps={{ style: { fontSize: 12, color: "#000" } }} // font size of input text
              InputLabelProps={{ style: { fontSize: 12, color: "#000" } }}
            />
            {errorAuth.error && (
              <p style={{ fontSize: 12, color: "red", fontWeight: 400 }}>
                {errorAuth.message}
              </p>
            )}
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label={dictionary.Forcepassword.second_input}
              type="email"
              fullWidth
              variant="standard"
              value={credentials.newPassWord}
              onChange={(e) =>
                setCredentials({ ...credentials, newPassWord: e.target.value })
              }
              inputProps={{ style: { fontSize: 12, color: "#000" } }} // font size of input text
              InputLabelProps={{ style: { fontSize: 12, color: "#000" } }}
            />
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label={dictionary.Forcepassword.third_input}
              type="email"
              fullWidth
              variant="standard"
              value={credentials.confirmPassword}
              onChange={(e) =>
                setCredentials({
                  ...credentials,
                  confirmPassword: e.target.value,
                })
              }
              inputProps={{ style: { fontSize: 12, color: "#000" } }} // font size of input text
              InputLabelProps={{ style: { fontSize: 12, color: "#000" } }}
            />
          </DialogContent>
          <DialogActions>
            {
              <Button
                disabled={Object.values(credentials).some((v) => v === "")}
                /* onClick={handleClose} */ onClick={() => handleSubmit()}
                variant="contained"
                sx={{
                  backgroundColor: THEME_CONTEXT.DAY_MODE_BTN,
                  fontSize: 12,
                  marginRight: 2,
                }}
              >
                {dictionary.Forcepassword.send}
              </Button>
            }
          </DialogActions>
        </Dialog>
      </div>
      <Snackbar
        severity={snackbar.severity}
        visible={snackbar.visible}
        message={snackbar.message}
      />
    </>
  );
};

export default ListCourses;
